import React from "react";
import MainImage from "./Components/MainImage";
import "../Components/text.css";
import About from "./Components/About";
import "../Home/Home.css";
import People from "./Components/People";
// import Datatab from "./Components/datatab";
import Insights from "./Components/Insights";
import Scroll from "./Components/Scroll";
import PartnerAndClients from "./Components/PartnerAndClient"
import Product from "./Components/Product";

function Homepage() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <MainImage />
      <div className="margins"></div>
      <div className="margins"></div>
      <Scroll />
      <div className="margins"></div>
    
      <Product />
      <div className="margins"></div>
        <About />
      <div className="margins"></div>
      <People />
      <div className="margins"></div>
      <PartnerAndClients/>
      <div className="margins"></div>
      {/* <Datatab />
      <div className="margins"></div>
      <div className="margins"></div> */}
      <Insights />
    </div>
  );
}

export default Homepage;